import React from "react";
import styled from "@emotion/styled";
import { Link } from "gatsby";
// utils
import { Color } from "../../utils/color";

export const GenreCard = (props) => {
  return (
    <SCard>
      <Link to={props.url}>
        <img src={props.img} alt="genre" />
        <span>{props.txt}</span>
      </Link>
    </SCard>
  );
};

const SCard = styled.div`
  a {
    aspect-ratio: 1/1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    background-color: ${Color.gray100};
    position: relative;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      object-position: center;
    }
    span {
      position: absolute;
      bottom: 1rem;
      color: ${Color.gray400};
      font-size: 0.9rem;
      font-weight: 700;
      line-height: 1;
    }
  }
`;
